import { configureStore as configureStoreToolkit, } from '@reduxjs/toolkit';
import { logActionMiddleware } from './logger-middlewares.js';
export function configureStore({ reducer, preloadedState, middlewares = [], thunkExtraArguments, name, }) {
    return configureStoreToolkit({
        reducer,
        preloadedState,
        devTools: {
            stateSanitizer: (state) => state.history
                ? { ...state, history: '<<OMIT>>' }
                : state,
            name,
            shouldHotReload: false, // KIT-961 -> Redux dev tool + hot reloading interacts badly with replaceReducers mechanism.
        },
        middleware: (getDefaultMiddleware) => getDefaultMiddleware({ thunk: { extraArgument: thunkExtraArguments } })
            .prepend(...middlewares)
            .concat(logActionMiddleware(thunkExtraArguments.logger)),
    });
}
